/**
 * 获取输入内容的长度
 * @param value
 * @return 内容的长度
 */
export const getInputSize = value => {
  if (!value) {
    return 0;
  }
  const charCount = value.split("").reduce((prev, curr) => {
    // 英文字母和数字等算一个字符；这个暂时还不完善；
    if (/[a-z]|[0-9]|[,;.!@#-+/\\$%^*()<>?:"'{}~]/i.test(curr)) {
      return prev + 1;
    }
    // 其他的算是2个字符
    return prev + 2;
  }, 0);

  // 向上取整，防止出现半个字的情况
  return Math.ceil(charCount / 2);
};

/**
 * @description: 表情转码
 * @param {String} str 要转化的字符串
 * @return {String} 转化字符串
 */
export function utf16ToEntities(str) {
  const reg = /[\ud800-\udbff][\udc00-\udfff]/g; // 检测utf16字符正则
  str = str.replace(reg, char => {
    let H, L, code, s;

    if (char.length === 2) {
      H = char.charCodeAt(0); // 取出高位
      L = char.charCodeAt(1); // 取出低位
      code = (H - 0xd800) * 0x400 + 0x10000 + L - 0xdc00; // 转换算法
      s = `&#${code};`;
    } else {
      s = char;
    }

    return s;
  });

  return str;
}

/**
 * @description: 表情解码
 * @param {String} str   * @return {*}
 */
export function entitiesToUtf16(str) {
  // 判断是否存在
  if (str) {
    const reg = /&#\d+;/g;
    const arr = str.match(reg) || [];

    let H, L, code;

    for (let i = 0; i < arr.length; i += 1) {
      code = arr[i];
      code = code.replace("&#", "").replace(";", "");
      // 高位
      H = Math.floor((code - 0x10000) / 0x400) + 0xd800;
      // 低位
      L = ((code - 0x10000) % 0x400) + 0xdc00;
      code = `&#${code};`;
      const s = String.fromCharCode(H, L);
      str = str.replace(code, s);
    }
    return str;
  } else {
    return str;
  }
}

/* 删除文本中的emjoy */

export function haveEmoji(str) {
  //1.正则 2.emoji-regex库
  let emojiReg = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi;
  const mm = emojiReg.test(str);
  // if (mm) {
  // 	Taro.showToast({
  // 		title: '不能输入emoji！',
  // 		icon: 'none',
  // 		duration: 2000,
  // 	})
  // }
  const strResult = str.replace(emojiReg, "");
  return strResult;
}



// WEBPACK FOOTER //
// ./src/utils/utils.js